import { DURUS_SAFI, meslegeGoreDuruslar, safDegistirirMi } from '@kurultay/tipler'
import type { Kahraman } from './tipler.js'

export function durusDegistirilebilirMi(k: Kahraman): boolean {
  return k.yasiyor && !k.buTurDurusDegisti
}

/**
 * Kahramanı silah çiftinin diğer yarısına geçirir. Yeni nesne döner.
 * Saf değiştiren mesleklerde (Akıncı, Kargıcı) bu tur alınacak ilk hasar artar —
 * saf değiştirmek bedavaya gelmemeli.
 */
export function durusDegistir(k: Kahraman): Kahraman {
  const [a, b] = meslegeGoreDuruslar(k.meslek)
  const yeniDurus = k.durus === a ? b : a
  return {
    ...k,
    durus: yeniDurus,
    saf: DURUS_SAFI[yeniDurus],
    buTurDurusDegisti: true,
    durusCezasiAktif: safDegistirirMi(k.meslek),
  }
}

/** Her turun başında çağrılır: tur başına bir kez kuralını ve cezayı sıfırlar. */
export function turBasindaSifirla(k: Kahraman): Kahraman {
  return { ...k, buTurDurusDegisti: false, durusCezasiAktif: false }
}
